'use client'

import DropdownButton from '@/components/common/DropdownButton'
import { useDropdown } from '@/hooks/useDropdown'
import { useI18n } from '@/hooks/useI18n'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { APPSTORE_LINK, GOOGLEPLAY_LINK } from '@/constants/links'
import { GA_EVENTS } from '@/utils/analytics'

const HeaderClient = () => {
  const { isDropdownOpen, toggleDropdown, closeDropdown } = useDropdown()
  const [isScrolled, setIsScrolled] = useState(false)
  const { changeLanguage } = useI18n()
  const { t } = useTranslation('home')

  const [storeLink, setStoreLink] = useState('#')

  const handleLanguageChange = (language: 'ko' | 'en' | 'zh-CN' | 'zh-TW' | 'jp') => {
    changeLanguage(language)
    closeDropdown()
    GA_EVENTS.LANGUAGE_CHANGE(language)
  }

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    const platform = /iphone|ipad|ipod|mac|macintosh/.test(userAgent) ? 'ios' : 'android'
    GA_EVENTS.DOWNLOAD_START(platform as 'ios' | 'android')
    GA_EVENTS.BUTTON_CLICK('header_download')
  }

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod|mac|macintosh/.test(userAgent)) {
      setStoreLink(APPSTORE_LINK)
    } else {
      setStoreLink(GOOGLEPLAY_LINK)
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 mx-auto flex justify-between items-center py-4 px-6
        transition-all duration-300 ${isScrolled
          ? 'bg-white/10 backdrop-blur-md'
          : 'bg-transparent'
        }`}
    >
      <button
        id="locale-button"
        type="button"
        aria-label="locale-button"
        className="flex-1 text-left text-sm sm:text-lg tracking-[-0.05em] text-pure-black dark:text-pure-white"
        onClick={toggleDropdown}
      >
        {t('default_language')}
      </button>
      {isDropdownOpen && (
        <div className="absolute top-[60px] left-6 z-10 w-[120px] rounded-lg border bg-pure-white dark:bg-pure-black py-2">
          <DropdownButton
            label="한국어"
            onClick={() => handleLanguageChange('ko')}
          />
          <DropdownButton
            label="English"
            onClick={() => handleLanguageChange('en')}
          />
          <DropdownButton
            label="中文(繁體)"
            onClick={() => handleLanguageChange('zh-TW')}
          />
          <DropdownButton
            label="中文(简体)"
            onClick={() => handleLanguageChange('zh-CN')}
          />
          <DropdownButton
            label="日本語"
            onClick={() => {
              handleLanguageChange('jp')

            }}
          />
        </div>
      )}
      <h2 className="flex-1 text-end sm:text-center text-sm sm:text-lg tracking-[-0.05em] text-pure-black dark:text-pure-white">
        {t('catchphrase')}
      </h2>
      <Link
        href={storeLink}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden sm:block flex-1 text-right text-lg tracking-[-0.05em] text-pure-black dark:text-pure-white"
        onClick={handleDownloadClick}
      >
        DOWNLOAD THE APP
      </Link>
      <Link
        href='/business'
        className="hidden sm:block flex-1 text-right text-lg tracking-[-0.05em] text-pure-black dark:text-pure-white"
      >
        비즈니스 제휴 문의
      </Link>
    </header>
  )
}

export default HeaderClient
